import { InputTag } from 'mixs/base/input_mixin';
import { Global }       from 'mixs/orders/planner/model';
import { api }       from "apps/api";
export class LocationInserter extends InputTag {
  public init() {
    super.init();
    this.watch();
    let onSelectedLocation = (newVal: any, oldVal: any, objectPath: string) => { this.onSelectedLocation(newVal, oldVal, objectPath); }
    let onSelectedPerson = (newVal: any, oldVal: any, objectPath: string) => { this.onSelectedPerson(newVal, oldVal, objectPath); }
    this.watchData(this.fullScope() + '.location_id.value', onSelectedLocation)
    this.watchData(this.fullScope() + '.locations_person_id.value', onSelectedPerson)
  }
  public onChange(e){
  }
  public onClickInsert(e){
    let content = e.currentTarget.querySelector('pre').textContent;
    this.opts.callbackInsert(content)
  }
  public onSelectedLocation(location_id, b, c){
    if(location_id == '' || location_id == null){
      this.dispatch(
        {
          location_id:         { text: '', value: '' },
          locations_person_id: { text: '', value: '' }
        }
      );
    }else{
      setTimeout(() => {
        let newPath = '/locations/' + location_id + '/people/typeahead';
        let newValue = {locations_person_id: { typeahead: {get_action: newPath} }}
        let locationData = Global.getLocationData(location_id)
        if(locationData && locationData.who){
          newValue['who']= {value: locationData.who};
        }
        this.dispatch(newValue);
        this.getPerson(location_id);
      }, 10)
    }
  }
  getPerson(location_id){
    let payload = {
      url: '/locations/' + location_id + '/people/first'
    }
    api.get(payload)
      .then((data) => {this.onGetItem(data)})
      .catch((error) => {console.log(error);});
  }
  onGetItem(data){
    let newValue = {locations_person_id: { text: data.data.name, value: data.data.value }}
    if(data.data.insert_content != undefined){
      newValue['insert_content'] = data.data.insert_content;
    }
    this.dispatch(newValue);
  }
  onSelectedPerson(person_id, b, c){
    this.updateInsertContent()
  }
  updateInsertContent(){
    const data = this.getDataFromTagScope().locations_person_id
    const id = data.value;
    const candidates = data.typeahead.candidates;
    if(!data.typeahead.candidates){ return; }
    let insert_content = ''
    for(let i=0;i<candidates.length;i++){
      if(candidates[i].id.toString() == id){
        insert_content = candidates[i].insert_content;
        break;
      }
    }
    if(insert_content != ''){
      const newValue = {
        locations_person_id: data,
        insert_content: insert_content
      }
      this.dispatch(newValue);
    }
  }
  locationPrepared(){
    if(this.opts.location_id.value == '' || this.opts.location_id.value == undefined){ return false; }
    if(this.opts.locations_person_id.value == '' || this.opts.locations_person_id.value == undefined){ return false; }
    return true;
  }
}

riot.mixin('inputs.complex.location-inserter', LocationInserter as riot.TagMixin)
